import axios from "axios";
import { getAuthHeaders } from "../helpers";

/**
 * @function getClinicGroupList
 * @param id
 * @description This function  will fetch the clinic group list.
 */
export const getClinicGroupList = id => {
  const url = `${process.env.REACT_APP_SERVER_URL}/clinic_groups/clinics?clinic_id=${id}`;
  return axios.get(url, {
    headers: getAuthHeaders()
  });
};

/**
 * @function getUsersList
 * @param pageNo, searchText, stateName
 * @description This function  will fetch the users list.
 */
export const getUsersList = (pageNo, searchText, activeUsers) => {
  let url = `${process.env.REACT_APP_SERVER_URL}/admin/users?page=${pageNo}&perpage=10`;

  if (searchText) {
    url = url + "&search_text=" + searchText;
  }

  if (activeUsers === "ACTIVE") {
    url = `${url}&active_users=true`;
  }
  return axios.get(url, {
    headers: getAuthHeaders()
  });
};

/**
 * @function getUserDetails
 * @desc  get user details
 */

export const getUserDetails = userId => {
  let url = `${process.env.REACT_APP_SERVER_URL}/admin/users/${userId}`;
  return axios.get(url, {
    headers: getAuthHeaders()
  });
};

/**
 * @function getBillingDetails
 * @desc  fetch billing details
 */

export const getBillingDetails = userId => {
  let url = `${process.env.REACT_APP_SERVER_URL}/admin/users/${userId}/billing_payments`;
  return axios.get(url, {
    headers: getAuthHeaders()
  });
};

/**
 * @function generateCmsData
 * @desc  post user phone number
 */

export const generateCmsData = phone_number => {
  let url = `${process.env.REACT_APP_SERVER_URL}/admin/users/create_cms_data`;
  return axios.post(
    url,
    { phone_number: phone_number },
    {
      headers: getAuthHeaders()
    }
  );
};

/**
 * @function generateGrowthData
 * @desc  post user phone number
 */

export const generateGrowthData = phone_number => {
  let url = `${process.env.REACT_APP_SERVER_URL}/admin/users/create_growth_data`;
  return axios.post(
    url,
    { phone_number: phone_number },
    {
      headers: getAuthHeaders()
    }
  );
};

/**
 * @function broadcastWebUpgrade
 * @desc  Handle sending we upgrade notification
 */

export const broadcastWebUpgrade = params => {
  let url = `${process.env.REACT_APP_SERVER_URL}/web_upgrade`;
  return axios.post(url, params, {
    headers: getAuthHeaders()
  });
};

/**
 * @function broadcastRelogin
 * @desc  Handle sending relogin notification
 */

export const broadcastRelogin = () => {
  let url = `${process.env.REACT_APP_SERVER_URL}/admin/users/reset_web_version`;
  return axios.post(
    url,
    {},
    {
      headers: getAuthHeaders()
    }
  );
};

/**
 * @function updateUserFlags
 * @desc this will update the user status to block
 */

export const updateUserFlags = (data, id) => {
  const url = `${process.env.REACT_APP_SERVER_URL}/admin/users/${id}`;
  return axios.put(url, data, {
    headers: getAuthHeaders()
  });
};

/**
 * @function getSubscriptionPlans
 * @desc  fetch subscription plans
 */

export const getSubscriptionPlans = () => {
  let url = `${process.env.REACT_APP_SERVER_URL}/admin/billing_plans?plan_type=clinic`;
  return axios.get(url, {
    headers: getAuthHeaders()
  });
};

/**
 * @function saveManualSubscription
 * @desc  this will save subscription manunally
 */

export const saveManualSubscription = (data, id) => {
  let url = `${process.env.REACT_APP_SERVER_URL}/admin/users/${id}/billing_subscriptions/manual`;
  return axios.post(url, data, {
    headers: getAuthHeaders()
  });
};

/**
 * @function getUserDevices
 * @desc  fetch user decvices
 */

export const getUserDevices = (id, pageNo, deviceType) => {
  let url = `${process.env.REACT_APP_SERVER_URL}/admin/users/${id}/devices`;
  if (pageNo) url = `${url}?page=${pageNo}&perpage=10`;
  if (deviceType && deviceType !== "all")
    url = `${url}&device_type=${deviceType}`;
  return axios.get(url, {
    headers: getAuthHeaders()
  });
};

/**
 * @function deleteDevice
 * @desc this service handles single device deletion for a user
 */
export const deleteDevice = (id, deviceId) => {
  let url = `${process.env.REACT_APP_SERVER_URL}/admin/users/${id}/devices/${deviceId}`;
  return axios.delete(url, {
    headers: getAuthHeaders()
  });
};

/**
 * @function deleteDevice
 * @desc this service handles bulk devices deletion for a user
 */
export const deleteBulkDevices = (id, deviceType) => {
  let url = `${process.env.REACT_APP_SERVER_URL}/admin/users/${id}/delete_all`;
  if (deviceType && deviceType !== "all")
    url = `${url}&device_type=${deviceType}`;
  return axios.delete(url, {
    headers: getAuthHeaders()
  });
};
